/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface ReferencedWorkDTO
 */
export interface ReferencedWorkDTO  {
    /**
     * 
     * @type {number}
     * @memberof ReferencedWorkDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReferencedWorkDTO
     */
    oldId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferencedWorkDTO
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferencedWorkDTO
     */
    subseriesTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferencedWorkDTO
     */
    pubtype?: string;
}

/**
 * Check if a given object implements the ReferencedWorkDTO interface.
 */
export function instanceOfReferencedWorkDTO(value: object): value is ReferencedWorkDTO {
    return true;
}

export function ReferencedWorkDTOFromJSON(json: any): ReferencedWorkDTO {
    return ReferencedWorkDTOFromJSONTyped(json, false);
}

export function ReferencedWorkDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferencedWorkDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'oldId': json['oldId'] == null ? undefined : json['oldId'],
                  'title': json['title'] == null ? undefined : json['title'],
                  'subseriesTitle': json['subseriesTitle'] == null ? undefined : json['subseriesTitle'],
                  'pubtype': json['pubtype'] == null ? undefined : json['pubtype'],
    };
}

export function ReferencedWorkDTOToJSON(json: any): ReferencedWorkDTO {
    return ReferencedWorkDTOToJSONTyped(json, false);
}

export function ReferencedWorkDTOToJSONTyped(value?: ReferencedWorkDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'oldId': value['oldId'],
        'title': value['title'],
        'subseriesTitle': value['subseriesTitle'],
        'pubtype': value['pubtype'],
    };
}


